import { FC } from "react";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Login } from "@/components";
import styles from "./LoginPage.module.scss";


export const LoginPage: FC = () => {

  return (
    <div className={styles.LoginPanelContainer}>
      <Stack spacing="large">
        <Login />
      </Stack>
    </div>
  );
};

export default LoginPage;
